import { HomeModernIcon } from '@heroicons/react/24/outline';
import { createStaffMembersAdminPage } from './StaffMembersAdminPortal';

const HostelMembersAdmin = createStaffMembersAdminPage({
  apiBase: '/admin/hostel-members',
  entityLabel: 'Hostel Member',
  entityLabelPlural: 'Hostel Members',
  accent: '#ec4899',
  icon: HomeModernIcon,
  designationOptions: ['Warden', 'Assistant Warden', 'Mess In-Charge', 'Caretaker'],
  staffRole: 'hostel_member',
});

export default HostelMembersAdmin;
